import { Box, Center, Image, Td, Tr } from "@chakra-ui/react";
import { PropsWithChildren, useContext } from "react";
import { FormattedMessage } from "react-intl";

import { useRect } from "@nens/react/hooks";

import { TableContext } from "../rana-table";

interface TableEmptyProps {
  icon?: string | null;
}

export function TableEmpty({ icon, children }: PropsWithChildren<TableEmptyProps>) {
  const { containerRef } = useContext(TableContext);
  const rect = useRect(containerRef);
  const { width } = rect;

  // Calculate the possible height of tbody
  const height =
    rect.height -
    Array.from(
      containerRef.current?.querySelector("table")?.querySelectorAll(":scope > *:not(tbody)") ?? []
    ).reduce((sum, el) => sum + el.clientHeight, 0);

  return (
    <Tr>
      <Td p={0}>
        <Box minH={36}>
          <Center
            position="absolute"
            p={4}
            h={`${height}px`}
            w={`${width}px`}
            flexDirection="column"
            color="brand.deep_sea"
            textAlign="center"
            whiteSpace="pre-wrap"
          >
            {icon && (
              <Center mb={2} position="relative" flexGrow={1} w="full" maxH={52}>
                <Image position="absolute" height="full" src={icon} />
              </Center>
            )}
            {children}
          </Center>
        </Box>
      </Td>
    </Tr>
  );
}

TableEmpty.displayName = "TableEmpty";

const Offline = () => (
  <TableEmpty icon="no-internet">
    <FormattedMessage
      id="table.empty.offline"
      defaultMessage="Currently offline. Unable to load data."
    />
  </TableEmpty>
);

Offline.displayName = "TableEmpty.Offline";
TableEmpty.Offline = Offline;
